import "./Home.module.css";
import Encabezado from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HorarioDeLaCeremoniaYRecepcion from "./sections/HorarioDeLaCeremoniaYRecepcion";
import UbicacionesYMapa from "./sections/UbicacionesYMapa";
import ConfirmarAsistencia from "./sections/ConfirmarAsistencia";
import CodigoDeVestimentaYAlojamiento from "./sections/CodigoDeVestimentaYAlojamiento";
import ContactosDeEmergencia from "./sections/ContactosDeEmergencia";
import Buses from "./sections/Buses";
import DireccionParadaDeAutobusMap from "./sections/DireccionParadaDeAutobusMap";
import Accommodations from "./sections/Accommodations";
import Vestimenta from "./sections/Vestimenta";
import UploadPhotographs from "./sections/UploadPhotographs";
import PonentesDestacados from "./sections/PonentesDestacados";
import PieDePagina from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Encabezado />
      <Hero />
      <HorarioDeLaCeremoniaYRecepcion />
      <UbicacionesYMapa />
      <Buses />
      <ConfirmarAsistencia />
      <DireccionParadaDeAutobusMap />
      <Accommodations />
      <Vestimenta />
      <CodigoDeVestimentaYAlojamiento />
      <ContactosDeEmergencia />
      <PonentesDestacados />
      <UploadPhotographs />
      <PieDePagina />
    </div>;
}